import React from "react";

import { CancellationTablePage } from "./cancellationTable/cancellationTablePage";
import { CancellationFilterPage } from "./cancellationFilter/CancellationFilterPage";

import classes from "./cancellationPage.module.css";

export const CancellationPage = () => {
  return (
    <div className={classes.box}>
      <CancellationFilterPage />
      <CancellationTablePage />
    </div>
  );
};
